<script>
import goodsTopMenu from "@/components/goods/components/topMenu.vue";
import DeleteItem from "@/components/goods/delete/DeleteItem.vue";
import {createNamespacedHelpers} from "vuex";

const { mapState } = createNamespacedHelpers('bulkDelete')
export default {
  name: "GoodsDelete",
  components: {DeleteItem, goodsTopMenu},
  data() {
    return {
      isImporting: false,
      file: null,
      entity: 'products',
      confirmation: true,
      search: ''
    }
  },
  computed: {
    currentPage: function () {
      return this.offset;
    },
    ...mapState([
      'items',
      'pagination'
    ])
  },
  methods: {
    async save() {
      let formData = new FormData();
      formData.append('file', this.file);
      formData.append('entity', this.entity);
      this.$store.dispatch('bulkDelete/ADD_LIST', {data: formData, th: this});
      this.file = null;
    },
    updateList: function (page) {
      let params  = {
        limit: this.pagination.limit,
        page: page,
        search: this.search,
        entity: this.entity
      };
      this.$store.dispatch('bulkDelete/GET_LIST', params);
    }
  },
  created() {
    let params  = {
      limit: this.pagination.limit,
      page: this.pagination.currentPage,
      search: this.search,
      entity: this.entity
    };
    this.$store.dispatch('bulkDelete/GET_LIST', params);
  },
}
</script>

<template>
  <section class="goods-delete">
    <goods-top-menu></goods-top-menu>
    <b-container fluid class="mb-5">
      <b-row>
        <b-col sm="8">
          <b-form-file
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
              v-model="file">
          </b-form-file>
        </b-col>
        <b-col sm="1">
          <b-button v-if="!isImporting" v-on:click="save" class="but-add-task" variant="primary">Загрузить</b-button>
        </b-col>
        <b-col sm="3">
          <b-form-checkbox
              id="checkbox-1"
              v-model="confirmation"
              name="checkbox-1"
              :value="true"
              :unchecked-value="false"
          >
            <span class="text-danger">
              Удаление подтверждаю
            </span>
          </b-form-checkbox>
        </b-col>
      </b-row>
      <section v-if="isImporting" class="mr-sm-5">
        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
        In progress ...
      </section>
    </b-container>
    <b-container fluid>
      <b-row class="mb-3">
        <b-col>
          <DeleteItem :item="item" :confirmation="confirmation" v-for="item in items" :key="item.id"/>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <div class="overflow-auto">
            <b-pagination
                v-model="pagination.currentPage"
                :total-rows="pagination.total"
                :per-page="pagination.limit"
                @change="updateList"
            ></b-pagination>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </section>
</template>

<style scoped>

</style>